import { AutoGenerateSetting } from 'common/models'

export const findSelectedSettingId = (data: AutoGenerateSetting[], selectedTerm: number) =>
  data?.find(item => selectedTerm >= item.from_term_id && selectedTerm <= (item.to_term_id ?? selectedTerm))?.id ?? null
